/*
创建者 魏强(2018.1.30)
中华老字号 汇集臻品
*/
<template>
	<div class="china-item" id="huiju-wrapper">
        	<h2>
        		<img :src="chinaImg3" title="汇集臻品">
        	</h2>
            <div class="china-content-3">
            	<ul class="clearfix">
					<li v-for="item in data">
						<router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}">
							<img :src="item.imgUrl" :alt="item.tip"  />
				 		</router-link>
					</li>
                </ul>
            </div>
            <div class="more" v-if="hasMore">
            	<a href="javascript:;" id="china-more">
            		<img :src="chinaImg4" @click="fetchData" title="更多老字号">
            	</a>
            </div>
            <Alert type="warning" show-icon v-if="!hasMore">
		        温馨提示
		        <template slot="desc">
		        没有更多数据
		    	</template>
		    </Alert>
        </div>
</template>
<script>
import chinaImg3 from '../../assets/images/china/china-3.png';
import chinaImg4 from '../../assets/images/china/china-4.png';
import {zhlzhGoodsZhenPing} from 'api/home';
export default {
	//props:["data"],
	data(){
		return {
			chinaImg3,
			chinaImg4,
			pageNo:0,
			hasMore:true,
			data:[]
		}
	},
	created(){
		this.fetchData();
	},
	methods:{
		fetchData(){
			if(this.hasMore){
				let pageNo = this.pageNo;
				zhlzhGoodsZhenPing(++pageNo).then(json=>{
					this.pageNo=pageNo;
					if(json.resCode==1){
						let data = json.data;
						this.hasMore = data.hasMore;
						this.data=[...this.data,...data.list];
					}else{
						console.log("中华老字号-获取臻品数据失败")
					}
				});
			}
		}
	}
}
</script>
<style scoped>
	#huiju-wrapper ul li img{
		height: 278px;
		width: 328px;
	}
</style>



// WEBPACK FOOTER //
// influx.vue?168ffa4c